module.exports = __webpack_public_path__ + "static/media/mu.33b7d117.svg";